import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/store';

import { Configuration } from '@azure/msal-browser';
import { AuthUser, ArchivUser, Benutzer } from '@/models/AuthModels';

export type Getters = {
  authUser(state: State): AuthUser | null;
  isAdmin(state: State): boolean;

  azureUsername(state: State): string;
  msalConfig(state: State): Configuration | null;
  azureLogin(state: State): boolean;
  azureLoginAvailable(state: State): boolean;

  archivUsers(state: State): Array<ArchivUser>;
  notExistingArchivUsers(state: State): Array<ArchivUser>;
  benutzer(state: State): Array<Benutzer>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  authUser(state: State) {
    return state.authUser;
  },

  isAdmin(state: State) {
    return state.authUser?.isAdmin ?? false;
  },

  msalConfig(state: State) {
    return state.msalConfig;
  },

  azureUsername(state: State) {
    return state.azureUsername;
  },

  azureLogin(state: State) {
    return state.azureLogin;
  },

  azureLoginAvailable(state: State) {
    return state.azureLoginAvailable;
  },

  archivUsers(state: State) {
    return state.archivUsers;
  },

  notExistingArchivUsers(state: State) {
    // archivUsers without existing benutzer
    return state.archivUsers.filter((archivUser) => !state.benutzer.some((benutzer) => benutzer.identityUserId === archivUser.id));
  },

  benutzer(state: State) {
    return state.benutzer;
  },
};
